import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Alert } from '@models/alert';

@Component({
  selector: 'mdk-alert-message',
  templateUrl: './alert-message.component.html'
})
export class AlertMessageComponent {
  @Input() alert!: Alert | null;

  @Output() closeAlert = new EventEmitter<void>();

  onClickClose() {
    this.closeAlert.emit();
  }
}
